import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
import ReactDOM from 'react-dom';
var createPortal = ReactDOM.createPortal;

var Portal = function (_React$Component) {
    _inherits(Portal, _React$Component);

    function Portal(props) {
        _classCallCheck(this, Portal);

        var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));

        _this._container = _this.props.getContainer();
        return _this;
    }

    _createClass(Portal, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.children) {
                return createPortal(this.props.children, this._container);
            }
            return null;
        }
    }]);

    return Portal;
}(React.Component);

export default Portal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/input-item/Portal.js
// module id = null
// module chunks = 